(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orimodo-product-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('orimodo-product-editorial')) {
    customElements.define('orimodo-product-editorial', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.index = Number(this.dataset.start || 0);
        this.slides = [...this.querySelectorAll('.opd-slide')];
        this.thumbs = [...this.querySelectorAll('[data-slide]')];
        this.detailLinks = [...this.querySelectorAll('[data-piece-details]')];
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => this.show(this.index + Number(button.dataset.direction))));
        this.thumbs.forEach((button, index) => button.addEventListener('click', () => this.show(index)));
        this.querySelector('.opd-gallery').addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key) || event.target.closest('video,iframe,model-viewer')) return;
          event.preventDefault();
          this.show(this.index + (['ArrowRight','ArrowDown'].includes(event.key) ? 1 : -1));
          if (event.target.closest('.opd-thumbs')) this.thumbs[this.index].focus({preventScroll: true});
        });
        this.detailLinks.forEach(link => link.addEventListener('click', () => {
          try { sessionStorage.setItem('orimodo-product-scroll', JSON.stringify({path:location.pathname,y:scrollY,media:this.slides[this.index]?.dataset.mediaId})); } catch {}
        }));
        const params = new URLSearchParams(window.location.search);
        const mediaId = params.get('media');
        const pieceKey = params.get('piece');
        const match = this.slides.findIndex(slide => {
          if (mediaId) return slide.dataset.mediaId === mediaId;
          if (!pieceKey) return false;
          const key = pieceKey.toLowerCase().replace(/[^a-z0-9-]/g, '');
          if (!key) return false;
          return [slide.dataset.pieceKey, slide.dataset.mediaFile].some(value => {
            const candidate = (value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-');
            return (`-${candidate}-`).includes(`-${key}-`);
          });
        });
        this.show(match >= 0 ? match : this.index);
      }
      show(index) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, n) => {
          slide.hidden = n !== this.index;
          if (slide.hidden) {
            slide.querySelectorAll('video').forEach(video => video.pause());
            slide.querySelectorAll('iframe').forEach(frame => { const src = frame.src; frame.src = src; });
            slide.querySelectorAll('model-viewer').forEach(model => model.pause?.());
          }
        });
        this.thumbs.forEach((thumb, n) => thumb.setAttribute('aria-current', String(n === this.index)));
        const title = this.slides[this.index]?.dataset.mediaTitle.toLowerCase() || '';
        const piece = [...this.querySelectorAll('[data-piece-title]')].find(item => item.dataset.pieceTitle.toLowerCase().split(/[^a-z]+/).some(word => word.length > 3 && title.includes(word)));
        this.detailLinks.forEach(link => {
          const url = new URL(link.getAttribute('href'),location.href);
          url.searchParams.set('view','pieces');
          const preview = new URLSearchParams(location.search).get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id',preview);
          url.hash = piece?.dataset.pieceAnchor || '';
          link.href = url.toString();
        });
        const thumb = this.thumbs[this.index];
        const rail = this.querySelector('.opd-thumbs');
        if (thumb && rail) {
          const tr = thumb.getBoundingClientRect(), rr = rail.getBoundingClientRect();
          if (tr.top < rr.top || tr.bottom > rr.bottom) rail.scrollTop += tr.top - rr.top;
          if (tr.left < rr.left || tr.right > rr.right) rail.scrollLeft += tr.left - rr.left;
        }
        this.querySelector('[data-gallery-status]').textContent = `${this.index + 1} / ${this.slides.length}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
